import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import _ from 'lodash';
import Header from '../../components/header';
import OriginBasedLock from '../../components/origin-based-lock';
import hasUserInfo from '../../hocs/has-user-info';

class User extends React.Component {
  componentDidMount() {
    // this.props.onSetupSendbirdUser();
    // this.props.onLoadOnboardingState();
  }

  render() {
    return (
      <div className="page">
        <Header />
        { this.props.children }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  requiredOrigin: _.get(state, 'user.user.organisation.origin'),
  organisationName: _.get(state, 'user.user.organisation.name'),
});

export function mapDispatchToProps(dispatch) {
  return {
    // onSetupSendbirdUser: () => dispatch(setupSendbirdUser()),
    // onLoadOnboardingState: () => dispatch(loadOnboardingState()),
    dispatch,
  };
}

export default compose(
  hasUserInfo,
  connect(mapStateToProps, mapDispatchToProps),
)(User);



/** WEBPACK FOOTER **
 ** ./src/containers/user/index.js
 **/